export default "/images/claritask-hover-dark.svg?b43bce1bab4f7e920e0bc1f980d6db60";